import Login from "../components/Login";
import Home from '../components/Home';
import Workspace from "../components/Workspace";
const pagesData = [
  {
    path: "",
    element: <Login />,
    title: "LoginPage"
  },
  {
    path: "login",
    element: <Login />,
    title: "Login"
  },
  {
    path: "home",
    element: <Home />,
    title: "Home"
  },
  {
    path: "workspace",
    element: <Workspace />,
    title: "Workspace"
  }
];


export default pagesData;